<template>
  <div class="">
    <!-- <div class="pt-1 pb-4 bg-white border"  style="border-radius:8px;" v-if="filters!==null"> -->
    <div
      class="bg-white shadow-sm border border-light"
      :class="hideFilters ? 'p-0' : 'py-3'"
      style="border-radius: 8px"
    >
      <!-- <div class="py-3 px-5" v-if="show"> -->
      <div class="row g-0">
        <div class="col-md-9 col-12 mt-3 order-2 order-md-1">
          <div v-show="!hideFilters">
            <transition-group class="" name="slide-fade" tag="div">
              <div
                class="my-md-0 mb-3 px-3"
                v-for="(item, key, count) in selected_filters"
                :key="count"
              >
                <div
                  class="d-flex flex-md-row flex-column justify-content-stretch align-items-center g-0 gap-2 mb-2"
                  v-if="item.disabled"
                >
                  <!-- Code for checkbox -->
                  <div
                    class="col-md-2 col-12 pe-0 d-flex justify-content-between align-items-center"
                  >
                    <input
                      type="checkbox"
                      class="mx-auto form-check d-block"
                      :disabled="!showDeleteBtn(key)"
                      @change="checkboxInputHandler(item, key, page)"
                      :checked="item.checked"
                    />
                    <input
                      type="checkbox"
                      title="Toggle Hierarchy View"
                      v-model="item.hviewValue"
                      v-if="item.showHview"
                      class="mx-auto ms-2 d-block border"
                      id=""
                      style="accent-color: gold"
                    />
                    <h6
                      v-text="key"
                      class="text-dark fw-bold flex-grow-1 text-uppercase mb-0 text-wrap"
                      :class="
                        item.showHview
                          ? ' ps-md-2 ps-2 ms-md-0'
                          : ' ps-md-4 ps-2 ms-md-2'
                      "
                      style="
                        font-size: 14px;
                        word-break: break-word;
                        overflow-wrap: break-word;
                        white-space: normal;
                      "
                    ></h6>
                    <span
                      class="d-md-none d-block"
                      id="crossBtn"
                      v-if="showDeleteBtn(key)"
                      @click="deleteFilter(key)"
                      >&times;</span
                    >
                  </div>

                  <!-- Code for filter type selection -->
                  <div class="col-md-4 col-12 m-0 p-0">
                    <!-- {{ item.options_error_msg }} -->
                    <!-- {{ item }} -->
                    <!-- <small class="error-msg" v-text="item.options_error_msg"></small> -->
                    <multiselect
                      :disabled="item.lock_options"
                      required
                      class="custom_multiselect"
                      :class="item.options_error_msg ? 'validation-true' : ''"
                      :options="item.options"
                      v-model="item.selected_options"
                      @select="renderMultiselect($event, item, key, page)"
                      @remove="$forceUpdate()"
                      placeholder="Filter options"
                    >
                    </multiselect>
                  </div>

                  <!-- Code for all types of selection like str:inputbox,list:dropdown,date:datepicker etc.... -->

                  <div class="col-md-4 col-12">
                    <!-- <small class="error-msg" v-text="item.values_error_msg"></small> -->
                    <multiselect
                      v-if="item.type === 'list'"
                      class="custom_multiselect"
                      :options="item.values"
                      v-model="item.selected_values"
                      :class="item.values_error_msg ? 'validation-true' : ''"
                      @select="renderMultiselect($event, item)"
                      @remove="$forceUpdate()"
                      :placeholder="'Select ' + key"
                      label="name"
                      track-by="id"
                    ></multiselect>

                    <multiselect
                      v-if="item.type === 'mlist' && key == 'sub_client'"
                      class="custom_multiselect"
                      :options="item.values"
                      v-model="item.selected_values"
                      :class="item.values_error_msg ? 'validation-true' : ''"
                      :multiple="true"
                      :close-on-select="false"
                      @select="renderMultiselect($event, item)"
                      @remove="$forceUpdate()"
                      :placeholder="'Select ' + key"
                      label="sname"
                      track-by="id"
                    ></multiselect>

                    <multiselect
                      v-if="item.type === 'mlist' && key != 'sub_client'"
                      class="custom_multiselect"
                      :options="item.values"
                      v-model="item.selected_values"
                      :class="item.values_error_msg ? 'validation-true' : ''"
                      :multiple="true"
                      :close-on-select="false"
                      @select="renderMultiselect($event, item, key, page)"
                      @remove="renderMultiselect($event, item, key, page)"
                      :placeholder="'Select ' + key"
                      label="name"
                      track-by="id"
                    ></multiselect>

                    <input
                      v-else-if="item.type === 'str'"
                      @keypress.enter="() => applyFilter()"
                      @input="inputHandler(item)"
                      type="text"
                      class="filter_field form-control"
                      v-model="item.selected_values"
                      :placeholder="'Filter ' + key"
                      :class="item.values_error_msg ? 'validation-true-dp' : ''"
                    />

                    <div
                      class="m-0 p-0"
                      v-else-if="item.type === 'date'"
                      v-show="item.show"
                    >
                      <flatPickr
                        class="filter_field form-control bg-white"
                        :config="item.config"
                        ref="date_flatpickr"
                        placeholder="Select date"
                        :forFilter="key"
                        value=""
                        @on-change="getPickerDate($event, item)"
                        :class="
                          item.values_error_msg ? 'validation-true-dp' : ''
                        "
                      ></flatPickr>
                    </div>

                    <div class="m-0 p-0" v-else-if="item.type === 'time'">
                      <flatPickr
                        class="filter_field form-control bg-white"
                        :config="item.config"
                        ref="time_flatpickr"
                        value=""
                        :forFilter="key"
                        @on-change="getPickerTime($event, item)"
                        @on-ready="
                          item.selected_values = [item.config.defaultDate]
                        "
                        :class="
                          item.values_error_msg ? 'validation-true-dp' : ''
                        "
                      ></flatPickr>
                    </div>

                    <div class="m-0 p-0" v-else-if="item.type === 'month'">
                      <datepicker
                        :minimumView="'month'"
                        ref="month_picker"
                        :maximumView="'year'"
                        class=""
                        @selected="getPickedMonth($event, item)"
                        :format="'yyyy-MM'"
                        :disabled-dates="disabledMonths"
                        :bootstrap-styling="true"
                      ></datepicker>
                    </div>

                    <!-- <input v-else @keypress.enter="applyFilter" type="text" class="form-control"> -->
                  </div>

                  <div class="col-md-4 border-0 d-md-block d-none">
                    <span
                      class=""
                      id="crossBtn"
                      v-if="showDeleteBtn(key)"
                      @click="deleteFilter(key)"
                      >&times;</span
                    >
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="row g-0">
              <!-- <div class="mt-1 offset-md-5 d-flex col-md-3 col-12 gap-2 justify-content-md-end justify-cotnent-center align-items-center px-0" v-if="showButtons()"> -->
              <div
                class="col-md-5 mt-md-1 offset-md-5 col-12 d-flex justify-content-md-end justify-content-center align-items-center gap-2"
                v-if="showButtons()"
              >
                <button
                  class="btn btn-primary btn-sm py-1"
                  style="width: 5rem"
                  @click="() => applyFilter()"
                >
                  Filter
                </button>
                <button
                  class="btn btn-outline-dark btn-sm"
                  style="width: 5rem"
                  @click="resetFilter"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          <div v-show="hideFilters">
            <div
              class="ps-3 d-flex flex-md-row flex-column align-items-center gap-3 mt-md-1 pb-3"
            >
              <h6 class="mb-0 d-block">Active Filters</h6>
              <div class="d-flex flex-wrap gap-1">
                <small
                  class="border border-success text-success px-2 py-1 rounded-2"
                  v-for="filter in Object.entries(selected_filters)
                    .filter((item) => item[1].checked && item[1].disabled)
                    .map((item) => item[0])"
                >
                  {{ filter }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="[
            hideFilters ? 'ms-auto' : '',
            'pt-3 pe-md-3 ps-md-0 ps-3 col-md-3 col-12 order-1 order-md-1',
          ]"
        >
          <!-- Code for filter column selection -->
          <div
            class="d-flex justify-content-md-end justify-content-center align-items-center mb-md-3"
          >
            <template v-if="!hideFilters">
              <!-- <h6
                class="text-nowrap font-weight-bold pe-3"
                style="font-size: 16px"
              >
                Select Filter :
              </h6> -->
              <select
                id="filter_selection"
                class="form-control"
                v-model="filter_dropdown"
                @change="columnFilterHandler"
              >
                <option value="" selected>Select Filters</option>
                <option
                  :value="key"
                  v-for="(item, key, count) in filters"
                  :key="count"
                  v-text="key"
                  :disabled="item.disabled"
                ></option>
              </select>
            </template>
            <button
              v-if="Object.keys(selected_filters).length"
              class="btn btn-link"
              @click="toggleFilters"
              v-text="hideFilters ? 'Show' : 'Hide'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bg-white border text-center p-3" style="border-radius:8px"  v-else>
      <div class="spinner-border text-primary" style="width:3rem;height:3rem"></div>
    </div> -->
  </div>
</template>

<script>
import user from "@/ajax/user";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import multiselect from "vue-multiselect";
import EventBus from "@/helpers/event-bus";
import myMixin from "@/mixins/Permission";
import Datepicker from "vuejs-datepicker";
import { Swal } from "sweetalert2/dist/sweetalert2";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    flatPickr,
    multiselect,
    Datepicker,
  },
  mixins: [myMixin],
  data() {
    return {
      hideFilters: false,
      redmine_filter_copy: {},
      filters: null,
      selected_filters: {},
      filter_dropdown: "",
      date_config: {},
      time_config: {},
      month_config: {},
      data_not_loaded: "",
      data_load_msg: "",
      no_internet: "",
      disabled: false,
      summary: "",
      pass_validation: false,
      show_datepicker: true,
      current_user_index: null,
      redmine_filter_copy: null,
      disabledMonths: {
        from: new Date(),
      },
      isCollapsed: false,
      // show:true
    };
  },
  // inject: ["serverParams"],
  props: {
    page: {
      type: String,
    },
    set_filters: {
      type: Object,
      default: null,
    },
    serverParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState("userStore", ["currentUser"]),
    ...mapState("common", ["currentPage"]),
  },
  methods: {
    toggleFilters() {
      this.hideFilters = !this.hideFilters;
    },
    checkboxInputHandler(item, key, page) {
      item.checked = !item.checked;

      if ((page === "my_task" || page === "team_task") && key === "projects") {
        this.handleProjectChange(item, key);
      }

      this.$forceUpdate();
    },
    inputHandler(item) {
      // console.log(item);
      item.values_error_msg ? (item.values_error_msg = "") : "";
      this.$forceUpdate();
    },
    showDeleteBtn(key) {
      // let check=true;
      if (this.page === "tm_report") {
        if (key == "date" || key == "status") {
          // console.log("returned ---------- false")
          return false;
        }
      }

      if (this.page === "snapshot_report") {
        return key != "month";
      }

      if (this.page === "summary_team") {
        return key != "month" && key != "view type";
      }

      if (this.page === "users") {
        if (key == "status") {
          // console.log("returned ---------- false")
          return false;
        }
      }
      if (this.page === "my_task" || this.page === "team_task") {
        if (key == "date") {
          // console.log("returned ---------- false")
          return false;
        }
      }
      // this.$forceUpdate();
      return true;
    },
    renderMultiselect(event, item, key = "", page = "", filtername) {
      // console.log("renderMultiselect item", item, key, page);
      if ((page === "my_task" || page === "team_task") && key === "projects") {
        this.handleProjectChange(item, key);
      }
      this.$forceUpdate();
      this.optionEventHandler(item.type, event, item, key);
    },

    handleProjectChange(item, key) {
      if (item.checked === true) {
        this.handleProjectSelection(item, key);
      } else {
        this.resetMileStoneValues();
      }
    },

    handleProjectSelection(item, key) {
      let project_ids;
      if (
        this.selected_filters.projects.selected_values &&
        this.selected_filters.projects.selected_values.length > 0
      ) {
        project_ids = this.selected_filters.projects.selected_values.map(
          (item) => item.id
        );

        if (project_ids.length > 0) {
          let all_values = JSON.parse(
            JSON.stringify(this.filters.milestones.values)
          );
          if (item.selected_options === "is") {
            this.selected_filters.milestones.values = all_values.filter(
              (item) => {
                return project_ids.includes(item.project_id);
              }
            );
            this.selected_filters.milestones.selected_values = (
              this.selected_filters.milestones.selected_values || []
            ).filter((item) => {
              return project_ids.includes(item.project_id);
            });
          } else if (item.selected_options === "is not") {
            this.selected_filters.milestones.values = all_values.filter(
              (item) => {
                return !project_ids.includes(item.project_id);
              }
            );

            this.selected_filters.milestones.selected_values = (
              this.selected_filters.milestones.selected_values || []
            ).filter((item) => {
              return !project_ids.includes(item.project_id);
            });
          }
        }
      } else {
        this.resetMileStoneValues();
      }
    },
    resetMileStoneValues() {
      let all_values = JSON.parse(
        JSON.stringify(this.filters.milestones.values)
      );
      this.selected_filters.milestones.values = all_values;
    },

    // To hide or show the filter and reset button
    showButtons() {
      let bool = Object.values(this.selected_filters).some(
        (item) => item.disabled === true
      );
      return bool;
    },

    filterUserByDoe() {
      if (this.page == "tm_report" || this.page == "summary_team") {
        // console.log(Object.keys(this.selected_filters));
        if (Object.keys(this.selected_filters).includes("users")) {
          // Re assigning the users list
          this.selected_filters.users.values = structuredClone(
            this.filters.users.values
          );

          // Getting the range date
          let date_filters = this.selected_filters.date ? this.selected_filters.date.selected_values : this.selected_filters.month.selected_values;

          // Filtering the user base on the range date for doe
          this.selected_filters.users.values =
            this.selected_filters.users.values.filter((item) => {
              return (
                item.doe == null ||
                (item.doe != null &&
                  moment(item.doe).isBetween(
                    date_filters[0],
                    date_filters[1],
                    null,
                    []
                  ))
              );
            });

          if (this.selected_filters.users.selected_values.length != 0) {
            this.selected_filters.users.selected_values =
              this.selected_filters.users.selected_values.filter((item) => {
                return (
                  item.doe == null ||
                  (item.doe != null &&
                    moment(item.doe).isBetween(
                      date_filters[0],
                      date_filters[1],
                      null,
                      []
                    ))
                );
              });
          }

          this.current_user_index =
            this.selected_filters.users.values.findIndex(
              (item) => item.id == this.currentUser.id
            );

          this.$forceUpdate();
        }
      }
    },

    // Below function is for the dropdown from which all filters are selected
    columnFilterHandler(event) {
      const filtername = event.target.value;
      // console.log("name", filtername);
      // console.log("filters beforeeeeeeeeeeeee..", this.selected_filters);
      // console.log("keys..", Object.keys(this.selected_filters));
      let filter_type = this.filters[filtername].type;

      if (this.hideFilters && Object.keys(this.selected_filters).length != 0) {
        this.hideFilters = false;
      }

      if (!Object.keys(this.selected_filters).includes(filtername)) {
        // console.log("doesn't include");
        // console.log("filters before..", this.selected_filters);
        // To add disabled option in the filters to disable the selected option dropdown
        this.filters[filtername].disabled = true;

        // To make a duplicate copy of the filters,this list is used to populate filters feild
        this.selected_filters[filtername] = Object.assign(
          {},
          JSON.parse(JSON.stringify(this.filters[filtername])),
          {
            checked: true,
            selected_values: null,
            selected_options: this.filters[filtername]["options"][0],
            options_error_msg: "",
            values_error_msg: "",
          }
        );

        // console.log("filters..", this.selected_filters);
        // console.log("cf..", this.selected_filters[filtername]);
        // This is to clear the dropdown
        this.filter_dropdown = "";
        this.selected_filters[filtername].disabled = true;
        // let filter_type = this.selected_filters[filtername].type;
        // console.log("filter type column", filter_type);
        if (filter_type == "date") {
          this.selected_filters[filtername]["show"] = true;
          this.$nextTick(() => {
            this.optionEventHandler(
              filter_type,
              this.filters[filtername]["options"][0],
              this.selected_filters[filtername],
              filtername
            );
          });
        }
      }

      if (Object.keys(this.selected_filters).includes(filtername)) {
        this.filters[filtername].disabled = true;
        this.selected_filters[filtername].disabled = true;
        this.$nextTick(() => {
          this.optionEventHandler(
            filter_type,
            this.filters[filtername]["options"][0],
            this.selected_filters[filtername],
            filtername
          );
        });
      }

      this.filter_dropdown = "";

      // if (filter_type === "month") {
      //   this.month_config = {
      //     plugins: [
      //       new monthSelectPlugin({
      //         shorthand: true, //defaults to false
      //         dateFormat: "m.y", //defaults to "F Y"
      //         altFormat: "F Y", //defaults to "F Y"
      //         theme: "dark" // defaults to "light"
      //       })
      //     ]
      //   };
      // }

      if (filter_type === "time") {
        this.time_config = {
          enableTime: true,
          noCalendar: true,
          dateFormat: "H:i",
          time_24hr: true,
          defaultDate: "00:00:00",
        };
        this.selected_filters[filtername].selected_values = [
          this.time_config.defaultDate,
        ];
        this.selected_filters[filtername]["config"] = this.time_config;
      } else if (filter_type === "date") {
        this.date_config = {
          disableMobile: true,
          dateFormat: "Y-m-d",
          mode: "single",
          enable: [
            {
              from: "2022-09-01",
              to: moment().format("YYYY-MM-DD"),
            },
          ],
        };
        this.selected_filters[filtername]["config"] = this.date_config;
      }
      
      // Call filterUserByDoe when users filter is added for summary_team
      if (this.page == "summary_team" && filtername == "users") {
        this.$nextTick(() => {
          this.filterUserByDoe();
        });
      }
      // this.$forceUpdate();
    },

    // To set value of time from flatpicker in filter object
    getPickerTime(time, item) {
      item.values_error_msg ? (item.values_error_msg = "") : "";
      item.selected_values = [];
      item.selected_values.push(moment(new Date(time)).format("HH:mm:ss"));
      this.$forceUpdate();
    },
    getPickedMonth(date, item) {
      let start_date = moment(date).startOf("month").format("YYYY-MM-DD");
      let end_date = moment(date).endOf("month").format("YYYY-MM-DD");
      item.selected_values = [start_date, end_date];
      // Clear week selection when month changes
      if (this.selected_filters.week) {
        this.selected_filters.week.selected_values = [];
      }
      // Populate weeks for the selected month
      this.populateWeeksForMonth(date);
      // Filter users by DOE when month changes
      if (this.page == "summary_team") {
        this.filterUserByDoe();
      }
    },
    populateWeeksForMonth(date) {
      if (!this.selected_filters.week) return;
      
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const baseDate = moment().toDate();
      baseDate.setFullYear(year);
      baseDate.setMonth(month - 1);
      baseDate.setDate(1);
      const firstDateOfMonth = moment(baseDate, "YYYY-MM-DD").startOf("month");
      const firstDateOfWeek = firstDateOfMonth.clone().startOf("isoWeek");
      const noOfWeeks = 5;
      const dates = [];
      let monday = firstDateOfWeek.clone();
      for (let i = 0; i < noOfWeeks; i++) {
        let sunday = monday.clone().endOf("isoWeek");
        dates.push({
          id: `${monday.format("YYYY-MM-DD")} to ${sunday.format("YYYY-MM-DD")}`,
          name: `${monday.format("Do MMM")} to ${sunday.format("Do MMM")} (Week ${i + 1})`,
          from_date: monday.format("YYYY-MM-DD"),
          to_date: sunday.format("YYYY-MM-DD"),
        });
        monday = monday.clone().add(1, "week");
      }
      this.selected_filters.week.values = dates;
      this.$forceUpdate();
    },
    // To set value of date from flatpicker in filter object
    getPickerDate(selected_dates, item) {
      item.values_error_msg ? (item.values_error_msg = "") : "";
      item.selected_values = [];
      item.selected_values = selected_dates.map((item) =>
        moment(item).format("YYYY-MM-DD")
      );
      this.$forceUpdate();
    },

    // Below function is to control all options Ex is,is not,is between etc... for datepicker and timepicker
    optionEventHandler(filter_type, filter_options, item, filter_name = null) {
      // To clear the value error for all kind of inputs on selection change
      // item.values_error_msg="";
      item.values_error_msg ? (item.values_error_msg = "") : "";
      item.options_error_msg ? (item.options_error_msg = "") : "";
      // Fallback in case filter_label is undefined

      let date_picker_index =
        filter_name != null
          ? Object.keys(this.selected_filters).indexOf(filter_name)
          : 0;

      if (filter_type === "date") {
        // Clearing out the selected list
        item.selected_values = null;
        // console.log("filtrename", filter_name);
        // console.log("this.$refs", this.$refs);
        let date_flatpickr = this.$refs.date_flatpickr.find(
          (e) => e.$attrs["forFilter"] == filter_name
        );
        // console.log("date_flatpickr", date_flatpickr);
        // console.log("--------- ",item);
        // console.log("selected values before ", item.selected_values);
        // Resting date filter
        // console.log(date_flatpickr);

        date_flatpickr.fp.clear();

        // To reset datepicker for single selection
        item.config.mode = "single";

        date_flatpickr.fp.input.disabled = false;
        // Modifying datepicker config and values
        if (filter_options === "is between") {
          item.config.mode = "range";
          item.show = true;
        } else if (filter_options === "this week") {
          let date_range = [
            moment().startOf("week").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          date_flatpickr.fp.setDate(date_range);
          item.selected_values = date_range;
          item.show = false;
        } else if (filter_options === "last week") {
          let date_range = [
            moment().startOf("week").subtract(7, "days").format("YYYY-MM-DD"),
            moment().endOf("week").subtract(7, "days").format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          // this.date_config.enable.length=0;
          date_flatpickr.fp.setDate(date_range);
          item.selected_values = date_range;
          item.show = false;
        } else if (filter_options === "this month") {
          let date_range = [
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          item.selected_values = date_range;
          date_flatpickr.fp.setDate(date_range);
          item.show = false;
        } else if (filter_options === "last month") {
          // console.log("last month", filter_type);

          let date_range = [
            moment().subtract("month", 1).startOf("month").format("YYYY-MM-DD"),
            moment().subtract("month", 1).endOf("month").format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          item.selected_values = date_range;
          // date_flatpickr[0].fp.setDate(date_range);
          item.show = false;
        } else if (filter_options === "last 3 months") {
          let date_range = [
            moment().subtract("month", 2).startOf("month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          item.selected_values = date_range;
          date_flatpickr.fp.setDate(date_range);
          item.show = true;
          date_flatpickr.fp.input.disabled = true;
        } else if (filter_options === "this year") {
          let date_range = [
            moment().startOf("year").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ];
          item.config.mode = "range";
          item.selected_values = date_range;
          date_flatpickr.fp.setDate(date_range);
          item.show = false;
        } else if (filter_options === "today") {
          let date_range = [moment().format("YYYY-MM-DD")];
          item.config.mode = "single";
          item.selected_values = date_range;
          date_flatpickr.fp.setDate(date_range);
          item.show = false;
        } else if (filter_options === "yesterday") {
          let date_range = [moment().subtract("day", 1).format("YYYY-MM-DD")];
          item.config.mode = "single";
          item.selected_values = date_range;
          date_flatpickr.fp.setDate(date_range);
          item.show = false;
        } else if (filter_options === "is") {
          item.config.mode = "single";
          item.show = true;
          if (this.set_filters) {
            item.selected_values = [
              moment(this.set_filters.date).format("YYYY-MM-DD"),
            ];
            date_flatpickr.fp.setDate(item.selected_values[0]);
          }
        } else if (filter_options === "is not") {
          item.config.mode = "single";
          item.show = true;
          if (this.set_filters) {
            item.selected_values = [
              moment(this.set_filters.date).format("YYYY-MM-DD"),
            ];
            date_flatpickr.fp.setDate(item.selected_values[0]);
          }
        } else if (filter_options === "in") {
          item.config.mode = "range";
          item.show = true;
        } else if (filter_options === "<=") {
          item.config.mode = "single";
          item.show = true;
        } else if (filter_options === ">=") {
          item.config.mode = "single";
          item.show = true;
        } else if (filter_options === "less than") {
          item.config.mode = "single";
          item.show = true;
        } else if (filter_options === "greater than") {
          item.config.mode = "single";
          item.show = true;
        } else {
        }
        if (this.page == "tm_report") {
          // console.log("Im called");
          this.filterUserByDoe();
        }
      }
      // console.log("values b ", this.selected_filters);

      this.$forceUpdate();
      // console.log("values a", this.selected_filters);
    },
    // To validate all filter options for empty values
    validator(skipValidation = false) {
      if (skipValidation) return true;

      let check = true;
      // console.log("selected values valid", this.selected_filters);
      if (Object.keys(this.selected_filters).length > 0) {
        // console.log(this.selected_filters);
        for (let i in this.selected_filters) {
          let obj = this.selected_filters[i];
          // console.log("obj", obj);
          obj["selected_values"] == ""
            ? (obj["selected_values"] = null)
            : obj["selected_values"] == []
            ? (obj["selected_values"] = null)
            : "";

          // For options dropdown------------
          if (
            obj["selected_options"] == null &&
            obj["disabled"] &&
            obj["checked"]
          ) {
            obj["options_error_msg"] = "** Options field cannot be empty **";
            check = false;
            // break;
          } else {
            obj["options_error_msg"] = "";
            check == false ? "" : (check = true);
          }

          // For values dropdown
          if (
            obj["selected_values"] == null &&
            obj["disabled"] &&
            obj["checked"] &&
            obj["type"] != "hidden"
          ) {
            obj["values_error_msg"] = "** Filter values cannot be empty **";
            check = false;
            // break;
          } else {
            // check=true;
            obj["values_error_msg"] = "";
            check == false ? "" : (check = true);
          }
        }
      }
      this.$forceUpdate();
      return check;
    },

    // To call api according to filter
    applyFilter(skipValidation = false) {
      // console.log("REDMINE ----- ", this.serverParams, this.page);
      // Below is the object which is going to be sent to api
      // console.log("validation",this.validator());
      if (this.validator(skipValidation)) {
        this.disabled = true;
        if (!skipValidation) {
          this.redmine_filter_copy = JSON.parse(
            JSON.stringify(this.selected_filters)
          );
        }
        let temp = JSON.parse(JSON.stringify(this.redmine_filter_copy));
        for (let i in temp) {
          // console.log(temp[i]);
          if (temp[i]["checked"] && temp[i]["disabled"]) {
            if (
              temp[i]["selected_values"] instanceof Object &&
              !(temp[i]["selected_values"] instanceof Array)
            ) {
              if (this.page == "tm_report" && i == "status") {
                temp[i]["selected_values"] = [
                  temp[i]["selected_values"]["name"],
                ];
              } else {
                temp[i]["selected_values"] = [temp[i]["selected_values"]["id"]];
              }
            }
            if (
              temp[i]["selected_values"] instanceof Object &&
              temp[i]["selected_values"] instanceof Array
            ) {
              // const exclude_pages = [
              //   "tm_report",
              //   "y_report",
              //   "users",
              //   "snapshot_report",
              //   "assets_history",
              //   "new_assets",
              //   "projects",
              //   "categories",
              //   "vendor",
              //   "milestones",
              //   "invoices",
              //   "quotes",
              //   "yr_goals",
              //   "tm_goals",
              // ];

              // const exclude_fields = [
              //   "projects",
              //   "teams",
              //   "users",
              //   "sub_client",
              //   "clients",
              //   "user role",
              //   "user type",
              //   "report_to",
              //   "approved_by",
              //   "organizations",
              //   "assets",
              //   "category",
              //   "manager",
              //   "status",
              //   "assigned by",
              //   "username",
              // ];
              if (
                // exclude_pages.includes(this.page) &&
                // exclude_fields.includes(i)
                temp[i]["type"] == "mlist"
              ) {
                let tempObj = temp[i]["selected_values"];
                temp[i]["selected_values"] = tempObj.map((item) => item.id);
                // temp[i]['selected_values']=[temp[i]['selected_values']['name']]
              }
            }
            // For merging the selected_options,selected_values array in the original values and options array
            temp[i]["options"] = temp[i]["selected_options"];
            temp[i]["values"] = temp[i]["selected_values"];
            // For deleting the temporary selected_values and selected_options array
            delete temp[i]["selected_options"];
            delete temp[i]["selected_values"];
            delete temp[i]["disabled"];
            delete temp[i]["checked"];
            delete temp[i]["options_error_msg"];
            delete temp[i]["values_error_msg"];
            delete temp[i]["show"];
            delete temp[i]["config"];
            //      delete this.redmine_filter_copy[i]["show"];
            // delete this.redmine_filter_copy[i]["config"];
            // console.log(temp,temp[i]);
          } else {
            delete temp[i];
          }
        }
        this.serverParams.filters = temp;
        // console.log("this.serverParams.filters", this.serverParams.filters);
        if (this.page == "users") {
          let showActiveUsers = true;
          let targetFilters = skipValidation
            ? this.redmine_filter_copy
            : this.selected_filters;
          user.search_user(this.serverParams).then((result) => {
            if (
              Object.keys(targetFilters).includes("status") &&
              targetFilters.status.selected_values &&
              targetFilters.status.selected_values.id == 1
            ) {
              showActiveUsers = false;
            }
            this.$emit(
              "redmine-filter-data",
              result.data.data.data,
              result.data.data.total,
              showActiveUsers
            );
          });
        }
        if (this.page == "yr_goals" || this.page == "tm_goals") {
          this.$emit("redmine-filter-data");
        }
        if (
          this.page == "projects" ||
          this.page == "templates" ||
          this.page == "milestones" ||
          this.page == "categories" ||
          this.page == "vendor" ||
          this.page == "invoices" ||
          this.page == "quotes"
        ) {
          this.$emit("redmine-filter-data");
        }

        if (this.page == "Clients" || this.page == "SubClients") {
          this.$emit("redmine-filter-data");
        }
        if (this.page == "team_task" || this.page == "my_task") {
          this.$emit("redmine-filter-data");
        }
        if (this.page == "y_report") {
          // console.log("=== YOUR REPORT")
          user.search_your_report(this.serverParams).then((result) => {
            this.$emit(
              "redmine-filter-data",
              result.data.data.data,
              result.data.data.total
            );
          });
          // this.$root.$emit("callFunction");
        }
        if (this.page == "snapshot_report") {
          user.getSnapshot(this.serverParams).then((result) => {
            this.$emit("redmine-filter-data", result.data.data);
          });
        }
        if (this.page == "assets_history") {
          user.getAssetsHistory(this.serverParams).then((result) => {
            this.$emit(
              "redmine-filter-data",
              result.data.data.data,
              result.data.data.total
            );
          });
        }
        if (this.page == "new_assets") {
          user.getAssets(this.serverParams).then((result) => {
            this.$emit(
              "redmine-filter-data",
              result.data.data.data,
              result.data.data.total,
              result.data.data.total_price
            );
          });
        }
        if (this.page == "summary_team") {
          this.$emit("redmine-filter-data", this.serverParams);
        }
        if (this.page == "tm_report") {
          // console.log("team report called")
          let params =
            Object.keys(this.selected_filters).length > 0
              ? this.selected_filters
              : {};
          EventBus.$emit("reset-page-perpage", {
            filters: {},
            sort: [
              {
                field: "",
                type: "asc",
              },
            ],
            page: 1,
            perpage: 100,
          });
          this.$emit("call-teammates-report", params);
          // this.$root.$emit("callTeammatesReport",this.selected_filters.status.selected_values);

          // To change the perpage and page tab selection to default values in CustomPaginationComponent
          // EventBus.$emit("reset-page-perpage", { page: 1, perpage: 100 });
        }
      }
      // this.serverParams.page = 1;
      // this.serverParams.perpage = 100;

      this.disabled = false;
    },

    // To reset the filters
    resetFilter() {
      if (this.page == "tm_report") {
        // For status
        this.selected_filters.status.selected_values =
          this.selected_filters.status.values[1];
        this.selected_filters.status.selected_options =
          this.selected_filters.status.options[0];

        if (
          this.currentUser.user_role == 1 ||
          this.currentUser.user_role == 3
        ) {
          !this.selected_filters.users.checked
            ? (this.selected_filters.users.checked = true)
            : null;
          if (!this.selected_filters.users.disabled) {
            this.selected_filters.users.disabled = true;
            this.filters["users"].disabled = true;
          }
          // For date
          this.selected_filters.date.selected_options =
            this.selected_filters.date.options[10];
          this.optionEventHandler(
            "date",
            "this month",
            this.selected_filters.date,
            "date"
          );
          // For user
          this.selected_filters.users.selected_options =
            this.selected_filters.users.options[1];
          this.selected_filters.users.selected_values = [
            this.selected_filters.users.values[this.current_user_index],
          ];
        } else {
          // For date
          this.selected_filters.date.selected_options =
            this.selected_filters.date.options[0];
          this.optionEventHandler(
            "date",
            "last month",
            this.selected_filters.date,
            "date"
          );
        }

        for (let i in this.selected_filters) {
          if (
            this.currentUser.user_role == 1 ||
            this.currentUser.user_role == 3
          ) {
            if (i != "date" && i != "status" && i != "users") {
              delete this.selected_filters[i];
              this.$forceUpdate();
            }
          } else {
            if (i != "date" && i != "status") {
              delete this.selected_filters[i];
              this.$forceUpdate();
            }
          }
        }
      } else if (this.page == "users") {
        this.columnFilterHandler({ target: { value: "username" } });
        if (this.currentUser.user_role == 1) {
          this.selected_filters.status.selected_values =
            this.selected_filters.status.values[0];
          this.selected_filters.status.selected_options =
            this.selected_filters.status.options[0];
        }
        this.selected_filters.username.selected_options =
          this.selected_filters.username.options[0];
        this.selected_filters.username.checked = false;
        this.selected_filters.username.selected_values = "";

        for (let i in this.selected_filters) {
          if (this.currentUser.user_role == 1) {
            // For admin users
            if (i != "status" && i != "username") {
              delete this.selected_filters[i];
            }
          } else {
            this.selected_filters.username.checked = false;
            if (
              i != "username" ||
              i == "doj" ||
              i == "user role" ||
              i == "user type" ||
              i == "login slot" ||
              i == "report to"
            ) {
              delete this.selected_filters[i];
            }
          }
        }

        this.$forceUpdate(); // Trigger a re-render after updating selected_filters
      } else if (this.page == "team_task" || this.page == "my_task") {
        if (this.page == "team_task") {
          this.selected_filters.users.selected_values = [];
          this.selected_filters.users.checked = false;
          this.selected_filters.users.selected_options =
            this.selected_filters.users.options[0];
          this.filters["users"].disabled = true;
          if (!this.selected_filters.users.disabled) {
            this.selected_filters.users.disabled = true;
          }
        }

        this.selected_filters.projects.checked = false;
        this.selected_filters.milestones.checked = false;
        this.selected_filters.search_task.checked = false;

        this.selected_filters.projects.selected_values = [];
        this.selected_filters.milestones.selected_values = [];
        this.selected_filters.search_task.selected_values = [];

        this.selected_filters.projects.selected_options =
          this.selected_filters.projects.options[0];
        this.selected_filters.milestones.selected_options =
          this.selected_filters.milestones.options[0];
        this.selected_filters.search_task.selected_options =
          this.selected_filters.search_task.options[0];

        if (!this.selected_filters.projects.disabled) {
          this.selected_filters.projects.disabled = true;
          this.filters["projects"].disabled = true;
        }
        if (!this.selected_filters.milestones.disabled) {
          this.selected_filters.milestones.disabled = true;
          this.filters["milestones"].disabled = true;
        }
        if (!this.selected_filters.search_task.disabled) {
          this.selected_filters.search_task.disabled = true;
          this.filters["search_task"].disabled = true;
        }
        let all_values = JSON.parse(
          JSON.stringify(this.filters.milestones.values)
        );
        this.selected_filters.milestones.values = all_values;

        this.selected_filters.date.selected_options =
          this.selected_filters.date.options[12];
        this.$nextTick(() => {
          this.optionEventHandler(
            "date",
            this.set_filters ? "is" : "last 3 months",
            this.selected_filters.date,
            "date"
          );
        });
      } else if (this.page == "snapshot_report") {
        this.$refs.month_picker[0].setValue(new Date());
        this.getPickedMonth(new Date(), this.selected_filters.month);
        for (let i in this.selected_filters) {
          if (i !== "month") {
            delete this.selected_filters[i];
          }
        }
      } else if (this.page == "assets_history") {
        // this.columnFilterHandler({ target: { value: "status" } });

        this.set_filters = null;
        this.columnFilterHandler({ target: { value: "date" } });

        // For date
        this.selected_filters.date.selected_options =
          this.selected_filters.date.options[11];

        this.selected_filters.date.checked = true;

        this.selected_filters.date.selected_values = [
          moment().startOf("year").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];

        for (let i in this.selected_filters) {
          if (i !== "date" && i !== "status") {
            delete this.selected_filters[i];
          }
          // else if (i !== "status") {
          // delete this.selected_filters[i];
          // }
        }

        // For status
        this.selected_filters.status.selected_options =
          this.selected_filters.status.options[0];
        this.selected_filters.status.selected_values =
          this.selected_filters.status.values[0];

        this.selected_filters.status.checked = true;

        this.$nextTick(() => {
          this.optionEventHandler(
            "date",
            "this year",
            this.selected_filters.date,
            "date"
          );
        });

        // if (!this.set_filters) {
        //   // For date
        //   this.selected_filters.date.selected_options =
        //     this.selected_filters.date.options[11];

        //   this.selected_filters.date.checked = true;

        //   this.selected_filters.date.selected_values = [
        //     moment().startOf("year").format("YYYY-MM-DD"),
        //     moment().format("YYYY-MM-DD"),
        //   ];

        //   this.$nextTick(() => {
        //     this.optionEventHandler(
        //       "date",
        //       this.set_filters ? "is" : "this year",
        //       this.selected_filters.date
        //     );
        //   });
        // }
      } else if (this.page == "new_assets") {
        // this.columnFilterHandler({ target: { value: "status" } });
        for (let i in this.selected_filters) {
          if (i !== "status") {
            delete this.selected_filters[i];
          }
        }
        this.selected_filters.status.selected_options =
          this.selected_filters.status.options[0];
        this.selected_filters.status.selected_values =
          this.selected_filters.status.values[0];

        this.selected_filters.status.checked = true;
      } else if (this.page == "summary_team") {
        // Reset to exact first load state - only keep month, projects, week, view type
        for (let i in this.selected_filters) {
          if (!["month", "projects", "week", "view type"].includes(i)) {
            delete this.selected_filters[i];
          }
        }
        
        // Re-initialize the 4 default filters to first load state
        this.columnFilterHandler({ target: { value: "month" } });
        this.columnFilterHandler({ target: { value: "projects" } });
        this.columnFilterHandler({ target: { value: "week" } });
        this.columnFilterHandler({ target: { value: "view type" } });
        
        // Set month with current date
        this.$refs.month_picker[0].setValue(new Date());
        this.getPickedMonth(new Date(), this.selected_filters.month);
        
        // Set default values matching first load
        this.selected_filters.month.checked = true;
        this.selected_filters.projects.checked = false;
        this.selected_filters.projects.selected_values = [];
        this.selected_filters.week.checked = false;
        this.selected_filters.week.selected_values = [];
        this.selected_filters["view type"].checked = true;
        
        this.selected_filters.projects.selected_options = this.selected_filters.projects.options[0];
        this.selected_filters.week.selected_options = this.selected_filters.week.options[0];
        this.selected_filters["view type"].selected_options = this.selected_filters["view type"].options[0];
        this.selected_filters["view type"].selected_values = [this.selected_filters["view type"].values[0]];
        
        this.$forceUpdate();
        this.applyFilter();
      } else {
        this.selected_filters = {};
      }
      for (let i in this.filters) {
        if (!Object.keys(this.selected_filters).includes(i)) {
          this.filters[i].disabled = false;
          this.filters[i].selected_values = null;
          this.filters[i].selected_options = null;
        }
        // if (this.page == "tm_report") {
        //   if (i !== "date" && i !== "status" && i !== "users") {
        //     this.filters[i].disabled = false;
        //     this.filters[i].selected_values = null;
        //     this.filters[i].selected_options = null;
        //   }
        // } else {
        //   this.filters[i].disabled = false;
        //   this.filters[i].selected_values = null;
        //   this.filters[i].selected_options = null;
        // }
      }
      this.filter_dropdown = "";
      if (this.page == "tm_report" || this.page == "users") {
        this.applyFilter();
        if (this.page == "users") {
          this.selected_filters.username.checked = true;
        }
      } else {
        this.serverParams.page = 1;
        this.serverParams.perpage = 100;
        this.$emit("reset-server-params", this.serverParams);
      }
      this.$forceUpdate();
    },

    // To delete the filters
    deleteFilter(key) {
      // if (key == "date") {
      //   delete this.selected_filters[key];
      //   this.filters[key].disabled = false;
      //   this.$forceUpdate();
      //   return;
      // }
      if (
        (this.page === "my_task" || this.page === "team_task") &&
        key === "projects"
      ) {
        this.resetMileStoneValues();
      }
      this.filter_dropdown = "";
      this.filters[key].disabled = false;
      this.selected_filters[key].disabled = false;
      this.selected_filters[key].checked = true;
      this.selected_filters[key].selected_values = null;
      this.selected_filters[key].selected_options = "is";
      this.selected_filters[key].options_error_msg = "";
      this.selected_filters[key].values_error_msg = "";
      // this.selected_filters[key].show = null;
      // this.selected_filters[key].config = null;
      if (
        Object.values(this.selected_filters).every(
          (item) => item.disabled === false
        )
      ) {
        this.selected_filters = {};
        this.applyFilter();
      }
      this.$forceUpdate();
    },
  },
  updated() {
    // console.log("UPDATED ---------- ");
    // console.log(this.serverParams);
  },

  mounted() {
    // console.log("remdine component mounted--");
    // console.log("MOUNTED ---------- ");
    // console.log(this.serverParams);
    this.getUserPermissions();
    EventBus.$on("parentEvent", (params) => {
      this.page = params;
      // console.log("REDMINE FILTER CALLED.....!");
      this.applyFilter();
      // console.log("from parent event",this.serverParams);
    });
    user.getUserFilters(this.page).then((result) => {
      this.filters = result.data.data;
      if (this.page == "tm_report") {
        this.columnFilterHandler({ target: { value: "date" } });
        this.columnFilterHandler({ target: { value: "status" } });

        // For status
        this.selected_filters.status.selected_values = this.set_filters
          ? this.selected_filters.status.values[2]
          : this.selected_filters.status.values[1];

        if (
          this.currentUser.user_role == 1 ||
          this.currentUser.user_role == 3
        ) {
          // For Users
          this.columnFilterHandler({ target: { value: "users" } });
          this.current_user_index =
            this.selected_filters.users.values.findIndex(
              (item) =>
                item.id ==
                (this.set_filters
                  ? this.set_filters.user_id
                  : this.currentUser.id)
            );
          this.selected_filters.users.selected_options = this.set_filters
            ? this.selected_filters.users.options[0]
            : this.selected_filters.users.options[1];
          this.selected_filters.users.selected_values = [
            this.selected_filters.users.values[this.current_user_index],
          ];

          // For date
          this.selected_filters.date.selected_options = this.set_filters
            ? this.selected_filters.date.options[1]
            : this.selected_filters.date.options[10];

          this.selected_filters.date.selected_values = this.set_filters
            ? [moment(this.set_filters.date).format("YYYY-MM-DD")]
            : [
                moment().startOf("month").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD"),
              ];

          this.$nextTick(() => {
            this.optionEventHandler(
              "date",
              this.set_filters ? "is" : "this month",
              this.selected_filters.date,
              "date"
            );
          });
        } else {
          // For date
          this.selected_filters.date.selected_options =
            this.selected_filters.date.options[0];

          this.selected_filters.date.selected_values = [
            moment()
              .subtract(1, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
          ];

          this.$nextTick(() => {
            // console.log(
            //   "this.selected_filters.date",
            //   this.selected_filters.date
            // );
            this.optionEventHandler(
              "date",
              "last month",
              this.selected_filters.date,
              "date"
            );
          });
        }
        this.applyFilter();
      } else if (this.page == "users") {
        this.columnFilterHandler({ target: { value: "username" } });
        this.selected_filters.username.checked = false;
        if (this.currentUser.user_role == 1) {
          this.columnFilterHandler({ target: { value: "status" } });
          this.selected_filters.status.selected_values =
            this.selected_filters.status.values[0];
        }

        this.applyFilter();
        this.selected_filters.username.checked = true;
        // console.log("hello users");
      } else if (this.page == "y_report") {
        this.columnFilterHandler({ target: { value: "date" } });
        this.selected_filters.date.selected_options =
          this.selected_filters.date.options[6];
        this.selected_filters.date.selected_values = [
          moment().format("YYYY-MM-DD"),
        ];
        this.$nextTick(() => {
          this.optionEventHandler(
            "date",
            "today",
            this.selected_filters.date,
            "date"
          );
        });

        // for request clarifications
        if (
          this.set_filters &&
          Object.keys(this.set_filters).includes(
            "show_clarification_requests"
          ) &&
          this.set_filters["show_clarification_requests"]
        ) {
          //  to select the report_is filter
          this.columnFilterHandler({ target: { value: "report_is" } });
          this.selected_filters.report_is.selected_options =
            this.selected_filters.report_is.options[0];
          this.selected_filters.report_is.selected_values =
            this.selected_filters.report_is.values[0];

          // to uncheck the data filter
          this.selected_filters.date.checked = false;
        }

        this.applyFilter();
      } else if (this.page == "team_task" || this.page == "my_task") {
        if (this.page == "team_task") {
          this.columnFilterHandler({ target: { value: "users" } });
          this.selected_filters.users.checked = false;
        }

        this.columnFilterHandler({ target: { value: "projects" } });
        this.columnFilterHandler({ target: { value: "milestones" } });
        this.columnFilterHandler({ target: { value: "date" } });
        this.columnFilterHandler({ target: { value: "search_task" } });
        this.selected_filters.projects.checked = false;
        this.selected_filters.milestones.checked = false;
        this.selected_filters.date.checked = true;
        this.selected_filters.search_task.checked = false;

        this.selected_filters.date.selected_options =
          this.selected_filters.date.options[12];

        this.selected_filters.date.selected_values = [
          moment().subtract("month", 2).startOf("month").format("YYYY-MM-DD"),
          moment().endOf("month").format("YYYY-MM-DD"),
        ];

        this.$nextTick(() => {
          this.optionEventHandler(
            "date",
            "last 3 months",
            this.selected_filters.date,
            "date"
          );
        });
        this.applyFilter();
      } else if (this.page == "snapshot_report") {
        this.columnFilterHandler({ target: { value: "month" } });
        this.$nextTick(() => {
          this.$refs.month_picker[0].setValue(new Date());
          this.getPickedMonth(new Date(), this.selected_filters.month);
          this.applyFilter();
        });
      } else if (this.page == "users") {
        if (this.currentUser.user_role == 1) {
          this.columnFilterHandler({ target: { value: "username" } });
          this.columnFilterHandler({ target: { value: "status" } });
          this.selected_filters.status.selected_values = this.set_filters
            ? this.selected_filters.status.values[1]
            : this.selected_filters.status.values[0];
          this.selected_filters.username.checked = false;
          this.selected_filters.status.checked = true;
        } else {
          this.columnFilterHandler({ target: { value: "username" } });

          this.selected_filters.username.checked = false;
        }
        this.applyFilter();
        // console.log("hello users");
      } else if (this.page == "assets_history") {
        if (this.set_filters) {
          this.columnFilterHandler({ target: { value: "assets" } });
          this.selected_filters.assets.selected_values =
            this.selected_filters.assets.values.filter(
              (i) => i.id == this.set_filters.asset_id
            );
          this.$forceUpdate();
        } else {
          this.columnFilterHandler({ target: { value: "date" } });
          // For date
          this.selected_filters.date.selected_options =
            this.selected_filters.date.options[11];

          this.selected_filters.date.selected_values = [
            moment().startOf("year").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ];

          this.$nextTick(() => {
            this.optionEventHandler(
              "date",
              "this year",
              this.selected_filters.date,
              "date"
            );
          });
        }

        this.columnFilterHandler({ target: { value: "status" } });

        // For status
        this.selected_filters.status.selected_options =
          this.selected_filters.status.options[0];
        this.selected_filters.status.selected_values =
          this.selected_filters.status.values[0];

        this.applyFilter();
      } else if (this.page == "new_assets") {
        this.columnFilterHandler({ target: { value: "status" } });
        if (this.set_filters) {
          this.columnFilterHandler({ target: { value: "assets" } });
          this.selected_filters.assets.selected_values =
            this.selected_filters.assets.values.filter(
              (i) => i.id == this.set_filters.asset_id
            );
          this.$forceUpdate();
        }

        // For status
        this.selected_filters.status.selected_options =
          this.selected_filters.status.options[0];
        this.selected_filters.status.selected_values =
          this.selected_filters.status.values[0];

        // For date
        // this.selected_filters.date.selected_options =
        //   this.selected_filters.date.options[11];

        // this.selected_filters.date.selected_values = [
        //   moment().startOf("year").format("YYYY-MM-DD"),
        //   moment().format("YYYY-MM-DD"),
        // ];

        // this.$nextTick(() => {
        //   this.optionEventHandler(
        //     "date",
        //     "this year",
        //     this.selected_filters.date
        //   );
        // });

        this.applyFilter();
      } else if (this.page == "summary_team") {
        this.columnFilterHandler({ target: { value: "month" } });
        this.columnFilterHandler({ target: { value: "projects" } });
        this.columnFilterHandler({ target: { value: "week" } });
        this.columnFilterHandler({ target: { value: "view type" } });
        
        // Set month as checked with current date
        this.selected_filters.month.checked = true;
        this.$nextTick(() => {
          this.$refs.month_picker[0].setValue(new Date());
          this.getPickedMonth(new Date(), this.selected_filters.month);
          // Apply filter after setting month picker
          this.$nextTick(() => {
            this.applyFilter();
          });
        });
        
        // Set default values for other filters
        this.selected_filters.projects.checked = false;
        this.selected_filters.week.checked = false;  // Don't show week by default
        this.selected_filters["view type"].checked = true;  // Make view type mandatory
        
        this.selected_filters.projects.selected_options = this.selected_filters.projects.options[0];
        this.selected_filters.week.selected_options = this.selected_filters.week.options[0];
        this.selected_filters["view type"].selected_options = this.selected_filters["view type"].options[0];
        this.selected_filters["view type"].selected_values = this.selected_filters["view type"].values[0];
        
        this.$forceUpdate();
      } else {
        this.applyFilter();
      }
    });
  },
};
</script>

<style scoped>
.filter_field {
  font-size: 16px;
  height: 32px;
  padding: 3px 10px;
  /* padding:0px; */
  /* border: 1px solid #e8e8e8; */
  border-radius: 5px;
  width: 100%;
  margin-bottom: 0px;
}

.validation-true-dp::placeholder {
  color: crimson;
}

.validation-true-dp {
  border: 1px solid crimson;
}

:deep .validation-true .multiselect__tags {
  border: 1px solid crimson;
  color: crimson;
}

:deep .validation-true .multiselect__placeholder {
  color: crimson;
}

:deep .validation-true .multiselect__select:before {
  border-color: crimson transparent transparent;
}

.custom_multiselect {
  min-height: 32px !important;
  font-size: 16px;
}

:deep .custom_multiselect .multiselect__tags {
  height: max-content !important;
  min-height: 32px !important;
  padding-top: 0px !important;
  /* background:gold; */
}

:deep .custom_multiselect .multiselect__input {
  margin-bottom: 0px !important;
  margin-top: 5px !important;
  padding: 0px !important;
  font-size: 14px;
}

:deep .custom_multiselect .multiselect__content-wrapper {
  font-size: 14px;
}

:deep .custom_multiselect .multiselect__tags .multiselect__tag {
  margin-bottom: 0px !important;
  font-size: 12px;
}

:deep .custom_multiselect .multiselect__single {
  font-size: 15px;
  padding: 0px 4px !important;
  padding-top: 5px !important;
  margin: 0px !important;
  min-height: 0px !important;
  /* height:32px !important; */
}

:deep .custom_multiselect .multiselect__select {
  height: 32px !important;
  min-height: 32px !important;
  margin: 0px !important;
  padding: 0px !important;
  min-height: auto !important;
  /* background-color:gold !important; */
}

:deep .custom_multiselect .multiselect__placeholder {
  padding: 4px 0px !important;
  margin: 0px;
}

option:disabled {
  background: lightgray;
}

#filter_selection {
  font-size: 14px;
  height: 34px;
  padding: 2px 10px;
  border: 1px solid #e8e8e8;
  width: 80%;
}

#crossBtn {
  font-size: 25px;
  font-weight: bold;
  color: crimson;
  cursor: pointer;
}

#crossBtn:hover {
  color: darkred;
}

input[type="checkbox"] {
  width: 1em;
  height: 1em;
  background: #4e73df;
}

.error-msg {
  color: red;
  display: block;
  position: absolute;
  /* left:-10px; */
  top: -1.2rem;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.7s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
